import './layer-loading.less';

const LayerLoading = ({ scale = 1 }: { scale?: number }) => {
    return (
        <div className="layer-loading-wrap">
            <div className="layer-loading" style={{ transform: `scale(${scale})` }}>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
    );
};

export default LayerLoading;
